var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-dialog",
    {
      staticClass: "comp-dialog",
      attrs: { autoclose: "", width: "1356px", height: "100%" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c("template", { slot: "default" }, [
        _vm.showQuoteDetails === "new"
          ? _c("div", { staticClass: "iframe-headers" }, [
              _c("div", { staticClass: "iframe-header-info start-16" }, [
                _vm.reloadIframe
                  ? _c("iframe", {
                      staticStyle: { border: "none" },
                      attrs: {
                        src: _vm.iframeURL,
                        width: "100%",
                        height: "100%",
                        title: "Contract Details",
                        id: "contractFrame",
                      },
                    })
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _c("div", [
          _c(
            "span",
            {
              ref: "reload",
              staticClass: "icon-close",
              on: { click: _vm.close },
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                _c("path", {
                  attrs: { d: "M12 0a12 12 0 1012 12A12 12 0 0012 0z" },
                }),
                _c("path", {
                  attrs: {
                    d: "M13.414 12l3.293 3.293a1 1 0 11-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 11-1.414-1.414L10.586 12 7.293 8.707a1 1 0 111.414-1.414L12 10.586l3.293-3.293a1 1 0 111.414 1.414z",
                    fill: "#fff",
                  },
                }),
              ]),
            ]
          ),
        ]),
        _vm.showQuoteDetails === "old"
          ? _c("div", { staticClass: "headers" }, [
              _c("div", { staticClass: "header-info start-16" }, [
                _c("div", { staticClass: "product-name" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.results))]),
                ]),
                _c("div", { staticClass: "disclose" }, [
                  _c("h6", [
                    _vm._v(_vm._s(_vm.$t("disclosure"))),
                    _c(
                      "span",
                      {
                        staticClass: "disclose-link",
                        on: { click: _vm.openDisclosure },
                      },
                      [_vm._v("https:ibkr.info/article/2966")]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "contract-details" }, [
                _c("div", { staticClass: "quote-details" }, [
                  _c("div", { staticClass: "quote-details-headers" }, [
                    _c("div", { staticClass: "quote-symprice" }, [
                      _c("h3", { staticClass: "symprice" }, [
                        _vm._v(_vm._s(_vm.marketData[7219]) + " "),
                        _c("span", { staticClass: "quote-details-data fg70" }, [
                          _vm._v(_vm._s(_vm.assetName) + " "),
                        ]),
                        _c("span", { staticClass: "quote-details-data fg50" }, [
                          _vm._v(_vm._s(_vm.listingExchange)),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "quote-details-widgets" }, [
                    _c("div", { staticClass: "summary" }, [
                      _vm.isSummary
                        ? _c(
                            "div",
                            [
                              _vm.summary.length === 0
                                ? _c("ib-progress-circular", {
                                    staticClass: "alignment",
                                    attrs: { width: "40px", height: "40px" },
                                  })
                                : _vm._e(),
                              _vm.summary
                                ? _c("span", [_vm._v(_vm._s(_vm.summary))])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c("div", [
                            _c("span", { staticClass: "warning" }, [
                              _c("svg", { attrs: { viewBox: "0 0 28 25" } }, [
                                _c("path", {
                                  attrs: {
                                    fill: "#ffc107",
                                    d: "M1.5 24.8a1.5 1.5 0 01-1.3-2.2L12.7.9a1.5 1.5 0 012.6 0l12.5 21.7a1.5 1.5 0 01-1.3 2.2z",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    fill: "#000",
                                    d: "M12.9 17.4L12.5 8h3l-.4 9.4h-2.3z",
                                  },
                                }),
                                _c("circle", {
                                  attrs: {
                                    fill: "#000",
                                    cx: "14",
                                    cy: "20.6",
                                    r: "1.5",
                                  },
                                }),
                              ]),
                            ]),
                            _c("span", { staticClass: "warn-message" }, [
                              _vm._v(
                                "There is no data available for the requested contract."
                              ),
                            ]),
                          ]),
                    ]),
                    _c("div", { staticClass: "fundamentals flex-flex" }, [
                      _c(
                        "div",
                        { staticClass: "fundamentals-details start-16 end-16" },
                        [
                          _c("li", [
                            _vm._v("Market Cap"),
                            _vm.ratios.marketcap
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.ratios.marketcap)),
                                ])
                              : !_vm.ratios.marketcap
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("P/E"),
                            _vm.ratios.pe
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.ratios.pe)),
                                ])
                              : !_vm.ratios.pe
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("Revenue/Shares"),
                            _vm.ratios.ttmrevps
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.ratios.ttmrevps)),
                                ])
                              : !_vm.ratios.ttmrevps
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("Price/Book"),
                            _vm.ratios.pricebook
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.ratios.pricebook)),
                                ])
                              : !_vm.ratios.pricebook
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("Price/Tangible Book"),
                            _vm.ratios.pricetangiblebook
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.ratios.pricetangiblebook)),
                                ])
                              : !_vm.ratios.pricetangiblebook
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("EPS Growth"),
                            _vm.ratios.epsgrowth
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.ratios.epsgrowth)),
                                ])
                              : !_vm.ratios.epsgrowth
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("Return on Equity"),
                            _vm.ratios.returnonequity
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.ratios.returnonequity)),
                                ])
                              : !_vm.ratios.returnonequity
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("Quick Ratio"),
                            _vm.ratios.qquickrati
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.ratios.qquickrati)),
                                ])
                              : !_vm.ratios.qquickrati
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "fundamentals-details end-16" },
                        [
                          _c("li", [
                            _vm._v("Consensus"),
                            _vm.forecast.consrecom
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.forecast.consrecom)),
                                ])
                              : !_vm.forecast.consrecom
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("Recommendation"),
                            _vm.forecast.projltgrowthrate
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.forecast.projltgrowthrate)),
                                ])
                              : !_vm.forecast.projltgrowthrate
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("Long Term Growth Rate"),
                            _vm.forecast.projpe
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.forecast.projpe)),
                                ])
                              : !_vm.forecast.projpe
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("Price to EPS"),
                            _vm.forecast.projsalesq
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.forecast.projsalesq)),
                                ])
                              : !_vm.forecast.projsalesq
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _vm._v("Salary(Quarterly) "),
                            _vm.forecast.targetprice
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v(_vm._s(_vm.forecast.targetprice)),
                                ])
                              : !_vm.forecast.targetprice
                              ? _c("span", { staticClass: "values" }, [
                                  _vm._v("-"),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "fund-detail end-16" }, [
                        _c("li", [
                          _vm._v("Dividend"),
                          _vm.marketData[7286]
                            ? _c("span", { staticClass: "values" }, [
                                _vm._v(_vm._s(_vm.marketData[7286])),
                              ])
                            : !_vm.marketData[7286]
                            ? _c("span", { staticClass: "values" }, [
                                _vm._v("-"),
                              ])
                            : _vm._e(),
                        ]),
                        _c("li", [
                          _vm._v("Dividend Yield"),
                          _vm.marketData[7287]
                            ? _c("span", { staticClass: "values" }, [
                                _vm._v(_vm._s(_vm.marketData[7287])),
                              ])
                            : !_vm.marketData[7287]
                            ? _c("span", { staticClass: "values" }, [
                                _vm._v("-"),
                              ])
                            : _vm._e(),
                        ]),
                        _c("li", [
                          _vm._v("Ex-Date"),
                          _vm.marketData[7288]
                            ? _c("span", { staticClass: "values" }, [
                                _vm._v(_vm._s(_vm.marketData[7288])),
                              ])
                            : !_vm.marketData[7288]
                            ? _c("span", { staticClass: "values" }, [
                                _vm._v("-"),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }